<template>
    <div>
        <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/oracleImplementation/oracleImplementation.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
          Oracle <br />
          Implementation
        </h1>
        <p class="drop-from-bottom">
            Seamless Oracle Implementation: <br />
            Empowering Your Business Transformation
        </p>
      </div>
    </div>
    </div>
</template>

<script src></script>